var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9255 4.97196C22.5217 3.79244 21.4128 3 20.1661 3L18.7742 3C17.3625 3 16.1534 4.01106 15.9036 5.40051L14.4512 13.4782L15.0165 11.5829C15.3852 10.347 16.5218 9.5 17.8115 9.5L23.0595 9.5L25.3056 10.809L27.4708 9.5H26.56C25.3133 9.5 24.2044 8.70756 23.8006 7.52804L22.9255 4.97196Z",
    fill: "url(#paint0_radial_56201_15508)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39619 27.0147C9.79595 28.2011 10.9082 29 12.1602 29H14.5725C16.1771 29 17.4803 27.704 17.4892 26.0995L17.5313 18.4862L16.9697 20.4033C16.6056 21.6461 15.4657 22.5 14.1707 22.5H8.8894L6.96419 21.0214L4.87988 22.5H5.77995C7.03188 22.5 8.14417 23.299 8.54393 24.4853L9.39619 27.0147Z",
    fill: "url(#paint1_radial_56201_15508)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7502 3H8.81278C5.68779 3 3.8128 7.08916 2.56281 11.1783C1.08189 16.0229 -0.855922 22.5021 4.7503 22.5021H9.66063C10.9616 22.5021 12.1051 21.6415 12.4659 20.3915C13.2785 17.5759 14.7502 12.4993 15.9015 8.65192C16.4759 6.73249 16.9544 5.08404 17.6887 4.05749C18.1004 3.48196 18.7865 3 19.7502 3Z",
    fill: "url(#paint2_linear_56201_15508)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7502 3H8.81278C5.68779 3 3.8128 7.08916 2.56281 11.1783C1.08189 16.0229 -0.855922 22.5021 4.7503 22.5021H9.66063C10.9616 22.5021 12.1051 21.6415 12.4659 20.3915C13.2785 17.5759 14.7502 12.4993 15.9015 8.65192C16.4759 6.73249 16.9544 5.08404 17.6887 4.05749C18.1004 3.48196 18.7865 3 19.7502 3Z",
    fill: "url(#paint3_linear_56201_15508)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 29H23.1855C26.3105 29 28.1855 24.9103 29.4355 20.8207C30.9164 15.9755 32.8542 9.49548 27.248 9.49548H22.3377C21.0367 9.49548 19.8932 10.3562 19.5325 11.6062C18.7198 14.4221 17.2481 19.4994 16.0967 23.3474C15.5223 25.2671 15.0439 26.9157 14.3096 27.9424C13.8979 28.518 13.2118 29 12.248 29Z",
    fill: "url(#paint4_radial_56201_15508)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 29H23.1855C26.3105 29 28.1855 24.9103 29.4355 20.8207C30.9164 15.9755 32.8542 9.49548 27.248 9.49548H22.3377C21.0367 9.49548 19.8932 10.3562 19.5325 11.6062C18.7198 14.4221 17.2481 19.4994 16.0967 23.3474C15.5223 25.2671 15.0439 26.9157 14.3096 27.9424C13.8979 28.518 13.2118 29 12.248 29Z",
    fill: "url(#paint5_linear_56201_15508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_56201_15508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5749 13.5466) rotate(-130.79) scale(11.294 10.7167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0955758,
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773185,
    stopColor: "#2253CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0736C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_56201_15508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.17512 21.9482) rotate(50.1613) scale(10.3261 10.1421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633728,
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923392,
    stopColor: "#C02B3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_56201_15508",
    x1: 8.15815,
    y1: 5.36306,
    x2: 9.68814,
    y2: 23.2406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156162,
    stopColor: "#0D91E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487484,
    stopColor: "#52B471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652394,
    stopColor: "#98BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937361,
    stopColor: "#FFC800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_56201_15508",
    x1: 9.52198,
    y1: 3,
    x2: 10.3574,
    y2: 22.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DCBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246674,
    stopColor: "#0588F7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_56201_15508",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8098 7.58585) rotate(109.453) scale(25.9448 31.3245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0661714,
    stopColor: "#8C48FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F2598A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFB152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_56201_15508",
    x1: 28.6739,
    y1: 8.30469,
    x2: 28.663,
    y2: 13.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0581535,
    stopColor: "#F8ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708063,
    stopColor: "#A86EDD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/copilot.0f1bc62bcdcb026274dcb4aff4074f87.svg";
export { ForwardRef as ReactComponent };